import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function Services() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">Our IGNITE Services</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive solutions designed to accelerate your financial services transformation and regulatory compliance
            </p>
          </div>
        </div>
      </section>

      {/* IGNITE REGULATORY */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-shield-check-fill text-3xl text-blue-600"></i>
                </div>
                <h2 className="text-4xl font-bold text-gray-900">IGNITE REGULATORY</h2>
              </div>
              
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">CaaS Compliance as a Service – 1 Week/Month</h3>
              
              <p className="text-lg text-gray-600 mb-6">
                A subscription-based advisory service that provides continuous regulatory monitoring, interpretation, and implementation support for financial institutions in the EU. Help financial institutions follow and efficiently implement evolving EU regulations.
              </p>
              
              <div className="space-y-6 mb-8">
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-4">What's Included Weekly:</h4>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                        <i className="ri-file-text-fill text-lg text-blue-600"></i>
                      </div>
                      <div>
                        <h5 className="text-lg font-semibold text-gray-900 mb-2">Monthly Regulatory Briefing</h5>
                        <p className="text-gray-600">PDF + call: concise summary of new EU & national regulatory developments</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                        <i className="ri-roadmap-fill text-lg text-blue-600"></i>
                      </div>
                      <div>
                        <h5 className="text-lg font-semibold text-gray-900 mb-2">Compliance Roadmap</h5>
                        <p className="text-gray-600">Tailored action plan showing what must be done, when, and by whom</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="bg-blue-50 rounded-lg p-6 mb-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Deliverables:</h4>
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <i className="ri-check-line text-blue-500 mr-2"></i>
                    <span className="text-gray-700">Executive summary pack</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-blue-500 mr-2"></i>
                    <span className="text-gray-700">PR &amp; client communications briefs</span>
                  </li>
                </ul>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6 mb-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Ideal for:</h4>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-blue-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">Mid-size banks, insurers, and FinTechs</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-blue-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">PR teams requiring regulatory updates</span>
                  </li>
                </ul>
              </div>
              
              <Link to="/contact">
                <Button size="lg">Subscribe to IGNITE REGULATORY</Button>
              </Link>
            </div>
            
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/067bfbc5552a5defaa954f201956f021.jpg"
                alt="Regulatory compliance monitoring"
                className="rounded-xl shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* IGNITE EXECUTION */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <img 
                src="https://readdy.ai/api/search-image?query=Project%20management%20office%2C%20strategic%20implementation%20planning%2C%20team%20collaboration%2C%20project%20timeline%20charts%2C%20business%20transformation%20process%2C%20professional%20meeting%20room%2C%20strategic%20planning%20session%2C%20PMO%20methodology&width=600&height=400&seq=execution-service&orientation=landscape"
                alt="Strategic project execution"
                className="rounded-xl shadow-lg object-cover w-full h-96"
              />
            </div>
            
            <div className="order-1 lg:order-2">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-rocket-fill text-3xl text-green-600"></i>
                </div>
                <h2 className="text-4xl font-bold text-gray-900">IGNITE EXECUTION</h2>
              </div>
              
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">PMO Kickstart – 6-Week Program Setup</h3>
              
              <p className="text-lg text-gray-600 mb-6">
                Set up or strengthen client's program management capabilities to drive impact across their transformation initiatives.
              </p>
              
              <div className="space-y-6 mb-8">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-green-600 font-bold text-sm">1</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Week 1-2: PMO Assessment &amp; Setup</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>• Review of existing programs, governance, tools</li>
                      <li>• Stakeholder interviews &amp; pain point mapping</li>
                      <li>• Setup of PMO structure (roles, cadence, dashboards)</li>
                    </ul>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-green-600 font-bold text-sm">2</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Week 3-4: Implementation Support</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>• Prioritization of key initiatives</li>
                      <li>• Definition of KPIs and success criteria</li>
                      <li>• Roadmap consolidation and resource alignment</li>
                    </ul>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-green-600 font-bold text-sm">3</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Week 5-6: Handover &amp; Coaching</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>• PMO toolkit delivery (templates, tracking tools)</li>
                      <li>• Team training &amp; coaching</li>
                      <li>• Steering committee support (optional)</li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="bg-green-50 rounded-lg p-6 mb-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Deliverables:</h4>
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    <span className="text-gray-700">Tailored PMO framework (playbook)</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    <span className="text-gray-700">Project tracking tools &amp; dashboards</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    <span className="text-gray-700">KPI plan &amp; governance model</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    <span className="text-gray-700">Optional: Steering deck &amp; RACI templates</span>
                  </li>
                </ul>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6 mb-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Ideal for:</h4>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-green-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">Heads of Transformation / Strategy</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-green-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">Operations or Change Directors</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-green-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">Fintechs scaling their operations or fundraising</span>
                  </li>
                </ul>
              </div>
              
              <Link to="/contact">
                <Button size="lg" className="bg-green-600 hover:bg-green-700">Start IGNITE EXECUTION</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* IGNITE LAUNCH */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-rocket-2-fill text-3xl text-orange-600"></i>
                </div>
                <h2 className="text-4xl font-bold text-gray-900">IGNITE LAUNCH</h2>
              </div>
              
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">Product Launch Fast Track – 4-Week Accelerator</h3>
              
              <p className="text-lg text-gray-600 mb-6">
                From concept to go-live roadmap — accelerate client's time-to-market. Help financial institutions design, position, and prepare the launch of a new product or offer (e.g., digital account, insurance product, investment service).
              </p>
              
              <div className="space-y-6 mb-8">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-orange-600 font-bold text-sm">1</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Week 1: Offer &amp; Customer Fit</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>• Deep-dive into the product idea (features, target, pricing)</li>
                      <li>• Value proposition refinement</li>
                      <li>• Customer segment mapping &amp; pain point analysis</li>
                    </ul>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-orange-600 font-bold text-sm">2</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Week 2: Competitive Benchmark &amp; Business Model</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>• Market and competitor analysis (features, pricing, UX)</li>
                      <li>• Revenue model and cost structure validation</li>
                      <li>• Key risks &amp; differentiators</li>
                    </ul>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-orange-600 font-bold text-sm">3</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Week 3: Go-to-Market &amp; Launch Plan</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>• Channel strategy (digital, advisor-led, partners)</li>
                      <li>• Messaging pillars &amp; key marketing actions</li>
                      <li>• Compliance / tech dependencies review</li>
                    </ul>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-orange-600 font-bold text-sm">4</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Week 4: Roadmap &amp; Executive Pack</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>• Launch timeline with critical path</li>
                      <li>• Roles &amp; responsibilities (RACI)</li>
                      <li>• Slide deck for internal validation or investor pitch</li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="bg-orange-50 rounded-lg p-6 mb-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Deliverables:</h4>
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <i className="ri-check-line text-orange-500 mr-2"></i>
                    <span className="text-gray-700">Positioning canvas &amp; value prop brief</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-orange-500 mr-2"></i>
                    <span className="text-gray-700">Go-to-market plan</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-orange-500 mr-2"></i>
                    <span className="text-gray-700">Launch roadmap</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-orange-500 mr-2"></i>
                    <span className="text-gray-700">Executive summary slide pack</span>
                  </li>
                </ul>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6 mb-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Ideal for:</h4>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-orange-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">Product or innovation teams in banks &amp; insurers</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-orange-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">Fintechs launching new features or services</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-orange-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">Strategy teams preparing for product committees or board approval</span>
                  </li>
                </ul>
              </div>
              
              <Link to="/contact">
                <Button size="lg" className="bg-orange-600 hover:bg-orange-700">Launch with IGNITE LAUNCH</Button>
              </Link>
            </div>
            
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Financial%20product%20launch%20strategy%20meeting%2C%20business%20team%20planning%20new%20digital%20banking%20service%2C%20product%20roadmap%20presentation%20on%20screen%2C%20go-to-market%20strategy%20workshop%2C%20innovation%20team%20collaboration%2C%20modern%20corporate%20boardroom%2C%20professional%20strategic%20planning%20session%2C%20clean%20minimalist%20environment&width=600&height=400&seq=launch-service&orientation=landscape"
                alt="Product launch strategy"
                className="rounded-xl shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* IGNITE CX */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-user-heart-fill text-3xl text-purple-600"></i>
                </div>
                <h2 className="text-4xl font-bold text-gray-900">IGNITE CX</h2>
              </div>
              
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">Digital Journey Diagnostic – 3-Week Sprint</h3>
              
              <p className="text-lg text-gray-600 mb-6">
                For banks, insurers, or fintechs looking to improve customer experience and digital performance. In just 3 weeks, identify pain points, quick wins, and high-impact improvements in digital customer journeys.
              </p>
              
              <div className="space-y-6 mb-8">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-purple-600 font-bold text-sm">1</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Week 1: Rapid Assessment</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>• Review of existing customer journeys (web, mobile, onboarding, servicing)</li>
                      <li>• Stakeholder interviews (product owners, CX, operations)</li>
                      <li>• Benchmark vs market standards and best practices</li>
                    </ul>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-purple-600 font-bold text-sm">2</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Week 2: Diagnosis &amp; Prioritization</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>• Mapping of friction points, conversion drop-offs, and process inefficiencies</li>
                      <li>• Identification of key improvement areas (UX, processes, tools, organization)</li>
                    </ul>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-purple-600 font-bold text-sm">3</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Week 3: Recommendations &amp; Roadmap</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>• Tailored action plan (quick wins vs long-term moves)</li>
                      <li>• Digital optimization roadmap</li>
                      <li>• Optional executive presentation &amp; next steps planning</li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="bg-purple-50 rounded-lg p-6 mb-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Deliverables:</h4>
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <i className="ri-check-line text-purple-500 mr-2"></i>
                    <span className="text-gray-700">Diagnostic summary (PDF)</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-purple-500 mr-2"></i>
                    <span className="text-gray-700">Prioritized improvement plan</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-purple-500 mr-2"></i>
                    <span className="text-gray-700">Executive-ready slide deck</span>
                  </li>
                </ul>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6 mb-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Ideal for:</h4>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-purple-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">Heads of Digital / CX in banks &amp; insurers</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-purple-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">Fintech founders scaling their platforms</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-line text-purple-600 mr-2 mt-1"></i>
                    <span className="text-gray-700">Transformation / innovation leaders preparing for broader change programs</span>
                  </li>
                </ul>
              </div>
              
              <Link to="/contact">
                <Button size="lg" className="bg-purple-600 hover:bg-purple-700">Start IGNITE CX Diagnostic</Button>
              </Link>
            </div>
            
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20banking%20mobile%20app%20interface%20on%20smartphone%20screen%2C%20seamless%20user%20journey%20through%20banking%20features%2C%20customer%20using%20mobile%20banking%20application%2C%20intuitive%20financial%20services%20digital%20experience%2C%20clean%20modern%20banking%20UX%20design%2C%20user-friendly%20digital%20payment%20interface%2C%20smooth%20customer%20touchpoints%20in%20fintech%20platform%2C%20professional%20minimalist%20banking%20technology&width=600&height=400&seq=cx-digital-journey&orientation=landscape"
                alt="Digital banking user journey"
                className="rounded-xl shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Service Comparison */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Choose Your IGNITE Service</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Compare our services to find the perfect fit for your current needs
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-transparent hover:border-blue-200 transition-all">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-fill text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">IGNITE REGULATORY</h3>
                <p className="text-gray-600">CaaS - 1 week/month</p>
              </div>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Monthly regulatory briefing</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Compliance roadmap</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Executive summary pack</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">PR communications briefs</span>
                </li>
              </ul>
              
              <Link to="/contact">
                <Button variant="outline" className="w-full">Get Started</Button>
              </Link>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-green-200 relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-green-600 text-white px-4 py-1 rounded-full text-sm font-medium whitespace-nowrap">Most Popular</span>
              </div>
              
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-rocket-fill text-3xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">IGNITE EXECUTION</h3>
                <p className="text-gray-600">6-week program setup</p>
              </div>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">PMO assessment &amp; setup</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Implementation support</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">PMO toolkit &amp; training</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Governance model</span>
                </li>
              </ul>
              
              <Link to="/contact">
                <Button className="w-full bg-green-600 hover:bg-green-700">Get Started</Button>
              </Link>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-transparent hover:border-orange-200 transition-all">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-rocket-2-fill text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">IGNITE LAUNCH</h3>
                <p className="text-gray-600">4-week accelerator</p>
              </div>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Product positioning &amp; fit</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Competitive benchmark</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Go-to-market plan</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Launch roadmap</span>
                </li>
              </ul>
              
              <Link to="/contact">
                <Button variant="outline" className="w-full">Get Started</Button>
              </Link>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-transparent hover:border-purple-200 transition-all">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-heart-fill text-3xl text-purple-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">IGNITE CX</h3>
                <p className="text-gray-600">3-week sprint</p>
              </div>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Digital journey assessment</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">CX diagnosis &amp; prioritization</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Optimization roadmap</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  <span className="text-gray-700">Executive presentation</span>
                </li>
              </ul>
              
              <Link to="/contact">
                <Button variant="outline" className="w-full">Get Started</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-purple-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to IGNITE Your Transformation?</h2>
          <p className="text-xl text-purple-100 mb-8 max-w-3xl mx-auto">
            Choose the service that best fits your needs, or let's discuss a custom combination of our IGNITE offerings.
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-purple-600 hover:bg-gray-100">
              Schedule a Consultation
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
